export const MARTECH_STONE_3SP_DESKTOP_EXPERIMENT = 'martech_stone_3sp_desktop_control_test';
export const AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC = 'aud_mobile_bx1047_single_pin_logic';
export const AUD_WEB_BX1122_PIN_UNIFICATION = 'aud_web_bx1122_pin_unification';

export const STONE_3SP_DESKTOP_EXPERIMENT_ENABLED_KEY = 'Martech.Stone3SPDesktopExperiment.Enabled';

export const EXPERIMENTS: string[] = [
  MARTECH_STONE_3SP_DESKTOP_EXPERIMENT,
  AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC,
  AUD_WEB_BX1122_PIN_UNIFICATION,
];
